import Vue from 'vue';
import storage from './storage'
import axios from 'axios';
import Cache from './cache'
import qs from 'qs'
import router from '../router';
import { Loading, Notify, Toast } from 'vant';
import { getCacheKey,timestampToTime } from './common';




// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//  axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'debug') {
//  axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'production') { 
//  axios.defaults.baseURL = '';
// }

// 超时时间
axios.defaults.timeout = 30000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


let cache = new Cache(axios, {
    requestInterceptorFn: config => {

        config = httpUrl(config);
        // //api版本
        // const VERSION = 'v1.';
        // let url = config.url;
        // let index = url.indexOf('/');
        // let pre = url.substring(0, index);
        // if (pre != 'http:' && pre != 'https:' && url.split('/').length <= 2) {
        //     config.url  = 'api/'+ VERSION + url;
        //     pre = 'api';
        // }
        // // 请求拦截自定义操作
        // if (process.env.NODE_ENV == 'production') {

        //     if (pre == 'http:' || pre == 'https:') {
        //         config.baseURL = url;
        //     } else {
        //         if (pre == 'api') {
        //             config.baseURL = 'http://apitp.tuijiewang.com';
        //         }
        //         // else if(pre == 'alipay'){
        //         //     config.baseURL = 'https://alipy.domain.com/pagepay/index.php';
        //         // }
        //         config.url = VERSION + url;
        //     }
        // }

        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        if (config.method === 'post') { // post请求时，处理数据
            config.data = qs.stringify({
                ...config.data //后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
            })
        }
        const token = storage.get('token');
        token && (config.headers.Authorization = token);
        // 需要将config对象通过 Promise 返回 cache 中 也可以使用new Promise的写法
        return Promise.resolve(config)
    },
    responseInterceptorFn: response => {
        // 响应拦截的自定义操作
        // if (!res.data.code) {
        //     // 需要将 res 通过 Promise 返回
        //     return Promise.resolve(res)
        // }
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        //loadinginstace.close(); // 响应成功关闭loading
        // console.log('response', response);
        if (response.status === 200) {
            let result = responseHandle(response);
            // console.log('result', result)
            return result ? Promise.resolve(response) : Promise.reject(response);

        } else {
            return Promise.resolve(response);
        }
    }
}) // 将当前 axios 对象传入 Cache 中





/** 
 * 请求成功特殊值统一处理 
 * @param {Number} status 请求失败的状态码
 */
const responseHandle = (response) => {

    let data = response.data;
    // console.log('是否弹窗-data',data);
    let notTip = data.notTip==false?false:true;
    // console.log('是否弹窗',notTip);
    let code = data.code || 'unkown';
    // 状态码判断
    switch (code) {
        case 'unkown':
            failTip('未知错误');
            return false
            break
        case -100:
            // let url = response.config.url;
            // storage.set('r_url', url);
            storage.remove('token');
            failTip('请登录');
            toLogin();
            break;

        case -99:
            return false;
            break;

        default:
            // console.log('code', code);
            if (code > 0) {
                return true;
            } else if (code <= 0) {
                if(notTip){
                    failTip(data.memo);
                    return false;
                }else{
                    return false;
                }
               
            }

            break;
    }
}


/** 
 * 请求失败后的错误统一处理 
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 404请求不存在
        case 404:
            failTip('请求的资源不存在');
            break;
        default:
            console.log(other);
    }
}



/** 
 * 提示函数 
 * 根据消息类型消息提示
 * Message 消息
 * Notification 通知
 * MessageBox 弹窗
 */
const successTip = (msg) => {

    Toast.success(msg);
}
const failTip = (msg) => {

    Toast.fail(msg);
}
/** 
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    router.replace({
        // path: '/loginMobile',
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    });
}


//环境变量 URL组装
const httpUrl = (config) => {
    //api版本
    const VERSION = 'v1.';
    let url = config.url;
    let index = url.indexOf('/');
    let pre = url.substring(0, index);
    if (pre != 'http:' && pre != 'https:' && url.split('/').length <= 2) {
        config.url = '/api/' + VERSION + url;
        pre = 'api';
    }
    // 请求拦截自定义操作
    if (process.env.NODE_ENV == 'production') {

        if (pre == 'http:' || pre == 'https:') {
            config.baseURL = url;
        } else {
            if (pre == 'api') {
                config.baseURL = 'https://apitp.tuijiewang.com';
            }
            config.url = VERSION + url;
        }
    }
    return config;
}

// 测试打开
// const httpUrl = (config) => {
//     //api版本
//     const VERSION = 'v1.';
//     let url = config.url;
//     let index = url.indexOf('/');
//     let pre = url.substring(0, index);
//     if (pre != 'http:' && pre != 'https:' && url.split('/').length <= 2) {
//         config.url = '/api/'+ url;
//         pre = 'api';
//     }
//     // 请求拦截自定义操作
//     if (process.env.NODE_ENV == 'production') {

//         if (pre == 'http:' || pre == 'https:') {
//             config.baseURL = url;
//         } else {
//             if (pre == 'api') {
//                 config.baseURL = 'http://test-api.tuijie1.com/interface/appvue.php/'; //正式地址
//             }
//             config.url = url;
//         }
//     }
//     return config;
// }


/*
 *callback('返回数据',true|false) false 表示返回数据过期
 *
 */
 Vue.prototype.$get = (url, params = {}, options = {}, callback) => {

    options.cache = options.cache === false ? false : true;
    //get 自动缓存，不缓存options 传入 cache:false
    if (Object.keys(params).length > 0) {
        options.params = params;
        //列表只缓存page:1 其他不作缓存
        if (params.page && params.page > 1) {
            options.cache = false;
        }
    }
    return new Promise(function(resolve, reject) {
        let cancelToken = options.cancelToken || false;
        if (cancelToken) {
            options.cancelToken = new axios.CancelToken(function executor(c) {
                _global.cancel = c;
            })
        }
        if (options.cache) {

            //缓存key name
            let cacheKey = options.cacheKey = getCacheKey(url, params);
            let expire = options.expire || 30; //缓存时间
            expire = expire * 1000;
            let config = httpUrl({ url });
            params = params ? JSON.stringify(params) : '';
            let cacheData = window['sessionStorage'].getItem(cacheKey);
            // console.log('cacheKey', cacheKey, 'cacheData', cacheData)
            if (cacheData) {
                cacheData = JSON.parse(cacheData);
                // console.log(timestampToTime(cacheData.expire,true),timestampToTime(cacheData.expire + expire,true),timestampToTime(Date.now(),true))
                if (cacheData.expire + expire > new Date().getTime()) {
                    //未过期
                    //console.log('使用_fetch缓存')
                    return callback(cacheData.result, true);
                } else {
                    //console.log('使用_fetch过期缓存', cacheKey)
                    callback(cacheData.result, false);
                }
            }
        }
        axios.get(url, options).then((res) => {
            //当调用取消请求时，res为undefined，0.22版本前
            if (res !== 'stop') {
                callback(res, true);
            }
        }).catch((err) => {
            console.log('_fetch err', err)
            reject(err.data)
        })
    });
}







export default axios



// WEBPACK FOOTER //
// ./src/box/http.js